import { IPhoneNumber, IPhoneNumberGroup } from '../interface'
import { NumberGroup } from './NumberGroup'

export const PhoneNumbers = ({
   numberGroups,
   showMessageCount = true,
   children = null,
   selectMode = false,
   onSelect = () => {},
   showAssignButton = false,
   selectedNumbers = [],
   onDelete = undefined,
   onAssign = undefined,
   checkboxMode = false,
   onCheckboxChange = undefined,
   anyItemChecked = false,
}: {
   numberGroups: IPhoneNumberGroup[]
   showMessageCount?: boolean
   children?: React.ReactNode
   selectMode?: boolean
   onSelect?: (number: IPhoneNumber) => void
   selectedNumbers?: IPhoneNumber[] | Set<string>
   showAssignButton?: boolean
   onDelete?: (number: IPhoneNumber) => void | undefined
   onAssign?: (number: IPhoneNumber) => void | undefined
   checkboxMode?: boolean
   onCheckboxChange?: (number: IPhoneNumber) => void
   anyItemChecked?: boolean
}) => {
   return (
      <div className="flex flex-col gap-y-6 h-full overflow-y-auto">
         {numberGroups.map((group) => (
            <NumberGroup
               onAssign={onAssign}
               key={group.areaCode}
               group={group}
               showMessageCount={showMessageCount}
               selectMode={selectMode}
               onSelect={onSelect}
               selectedNumbers={selectedNumbers}
               showAssignButton={showAssignButton}
               onDelete={onDelete}
               checkboxMode={checkboxMode}
               onCheckboxChange={onCheckboxChange}
               anyItemChecked={anyItemChecked}
            >
               {children}
            </NumberGroup>
         ))}
      </div>
   )
}
